<vitamui-dialog-header
  [stepper]="stepper"
  [subhead]="'RECLASSIFICATION.COMMON.TITLE' | translate"
  [title]="['RECLASSIFICATION.FIRST_STEP.SUBTITLE' | translate, 'RECLASSIFICATION.' + action() + '_STEP.TITLE' | translate]"
></vitamui-dialog-header>

<form [formRoot]="form" (keydown.enter)="$event.preventDefault()">
  <mat-dialog-content>
    <vitamui-stepper #stepper (selectionChange)="stepIndex.set($event.selectedIndex)">
      <cdk-step>
        {{ data.itemSelected | i18nPlural: selectedUnitMap | translate: { count: data.itemSelected } }}

        @if (childrenCountLoaded()) {
          <div class="mb-4">
            @if (shouldProposeExactChildrenCount()) {
              <a class="link-without-underline" (click)="loadExactCount()">
                <vitamui-badge [text]="badgeMessage()" color="red" decoration="filled"></vitamui-badge>
              </a>
            } @else {
              <vitamui-badge [text]="badgeMessage()" color="red" decoration="filled"></vitamui-badge>
            }
          </div>
        } @else {
          <div class="d-flex align-items-center">
            <mat-spinner diameter="20" color="accent" class="spinner-wrapper"></mat-spinner>
          </div>
        }

        @if (simplifiedParents().length >= 1 && simplifiedParents().length <= MAXIMUM_PARENTS) {
          <div class="text medium mb-2">
            {{ simplifiedParents().length | i18nPlural: currentParentFolderMap | translate: { nbParents: simplifiedParents().length } }}
          </div>
          @for (parent of simplifiedParents(); track parent.id) {
            <div class="text normal ml-3 mb-2">{{ parent.title }}</div>
          }
        } @else if (simplifiedParents().length > MAXIMUM_PARENTS) {
          <div class="text medium mb-2">{{ 'RECLASSIFICATION.FIRST_STEP.MORE_THAN_FIVE_CURRENT_PARENTS_FOLDERS' | translate }}</div>
        } @else if (simplifiedParents().length === 0) {
          <div class="light">{{ 'RECLASSIFICATION.COMMON.ARCHIVE_WITH_NO_PARENTS' | translate }}</div>
        }

        <p class="text bold primary">{{ 'RECLASSIFICATION.FIRST_STEP.SELECT_ACTION_MESSAGE_1' | translate }}</p>
        <div class="form-group">
          @if (actions().options) {
            <vitamui-select
              [formField]="form.action"
              (change)="onActionChange()"
              [options]="actions().options"
              [placeholder]="'RECLASSIFICATION.FIRST_STEP.SELECT_ACTION_MESSAGE_2' | translate"
              [enableSearch]="false"
            ></vitamui-select>
          }
        </div>

        @switch (action()) {
          @case ('REPLACE') {
            <div class="text danger">{{ 'RECLASSIFICATION.FIRST_STEP.ALERT_REMOVED_CURRENT_PARENTS_FOLDERS' | translate }}</div>
          }
          @case ('PULL') {
            <div class="text danger">{{ 'RECLASSIFICATION.FIRST_STEP.ALERT_NO_ATTACHMENT_CURRENT_PARENTS_FOLDERS' | translate }}</div>
          }
        }
      </cdk-step>

      @if (shouldSelectTarget()) {
        <cdk-step>
          @switch (data.appName) {
            @case ('ARCHIVE') {
              @if (action() === 'REPLACE') {
                <div class="text danger">
                  {{ 'RECLASSIFICATION.FIRST_STEP.ALERT_REMOVED_CURRENT_PARENTS_FOLDERS' | translate }}
                </div>
              }
              <mat-button-toggle-group
                [formField]="form.reclassificationMode"
                (change)="onModeChange($event.value)"
                class="my-3 vitamui-button-toggle-group"
              >
                @for (mode of reclassificationModes; track mode) {
                  <mat-button-toggle [value]="mode">
                    <span>{{ 'RECLASSIFICATION.COMMON.' + mode | translate }}</span>
                  </mat-button-toggle>
                }
              </mat-button-toggle-group>
              @switch (form.reclassificationMode().value()) {
                @case (ReclassificationMode.FILING_PLAN) {
                  <vitamui-library-filing-plan
                    [mode]="FilingPlanMode.SOLO"
                    [tenantIdentifier]="data.tenantIdentifier"
                    [formField]="form.multiSelect.filingPlan"
                  ></vitamui-library-filing-plan>
                }
                @case (ReclassificationMode.ARCHIVE_UNIT_ID) {
                  <div class="gap-3 align-items-stretch">
                    <vitamui-input
                      [formField]="form.singleSelect.id"
                      [placeholder]="'RECLASSIFICATION.COMMON.ATTACHMENT_GUID_LABEL' | translate"
                      [errorMessageMap]="{
                        targetGuid: 'RECLASSIFICATION.COMMON.GUID_ALREADY_EXISTS' | translate,
                        alreadyExistParents: 'RECLASSIFICATION.COMMON.ATTACHMENT_ALREADY_EXISTS' | translate,
                      }"
                    >
                    </vitamui-input>
                    <vitamui-input
                      [formField]="form.singleSelect.title"
                      [placeholder]="'RECLASSIFICATION.COMMON.TARGET_GUID_TITLE_LABEL' | translate"
                    ></vitamui-input>
                  </div>
                }
              }
            }
            @case ('COLLECT') {
              @if (action() === 'REPLACE') {
                <div class="text danger mb-3">
                  {{ 'RECLASSIFICATION.FIRST_STEP.ALERT_REMOVED_CURRENT_PARENTS_FOLDERS' | translate }}
                </div>
              }
              <div class="form-group">
                @if (projectUnits()) {
                  <vitamui-library-filing-plan
                    [mode]="FilingPlanMode.SOLO"
                    [formField]="form.multiSelect.filingPlan"
                    [dataSource]="projectUnits()"
                  >
                  </vitamui-library-filing-plan>
                }
              </div>
            }
          }
        </cdk-step>
      }
    </vitamui-stepper>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div>
      @if (isLastStep()) {
        <button type="submit" class="btn primary" [disabled]="invalidStep()">
          {{ 'COMMON.CONFIRM' | translate }}
        </button>
      }
      <vitamui-next-step [stepper]="stepper" [disabled]="invalidStep()"></vitamui-next-step>
      <button type="button" class="btn link cancel" (click)="onCancel()">{{ 'COMMON.UNDO' | translate }}</button>
    </div>
    <vitamui-previous-step [stepper]="stepper"></vitamui-previous-step>
  </mat-dialog-actions>
</form>
